import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import ImportPurchases from "../../core/modals/purchases/importpurchases";
import EditPurchases from "../../core/modals/purchases/editpurchases";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import AddPurchases from "../../core/modals/purchases/addpurchases";
import { useDispatch, useSelector } from "react-redux";
import { setheadertoggle } from "../../redux/toggle";
import {
  fetchCategory,
  fetchGroup,
  fetchProduct,
  fetchSection,
} from "../../redux/userSetting";
import AdminProductTable from "../../components/adminsitration/admintables/AdminProductTable";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { SaveProductBulkPrice } from "../../services/AdminApiServices";
import { exportMasterExcel, exportMasterPDF, printMasterReport } from "../../core/utils/MasterReportUtils";
import { Switch } from "antd";

const BulkEdit = () => {
  const { register, handleSubmit, setValue, getValues } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchProduct(branch));
    dispatch(fetchSection(branch.guid));
    dispatch(fetchCategory(branch.guid));
    dispatch(fetchGroup(branch.guid));
  }, []);
  useEffect(() => {
    setValue();
  }, []);

  const { togglehead } = useSelector((state) => state.headerToggle);
  const { branch } = useSelector((state) => state.branchlist);
  const [editableList, setEditableList] = useState([]);

  const { productList, sectionList, categoryList, groupList } = useSelector(
    (state) => state.usersetting
  );


//   useEffect(() => {
//   if (productList?.length) {
//     setEditableList(productList.map(p => ({
//       ...p,
//       name: p.name || "",
//       code: p.code || "",
//       category: p.category?.guid || "",
//       group: p.group?.guid || "",
//       cost: p.cost || 0,
//       basePrice: p.basePrice || 0,
//     })));
//   }
// }, [productList]);

useEffect(() => {
  if (productList?.length) {
    setEditableList(
      productList.map(p => {
        const dynamicFields = {};

        p.sectionWiseProductDetailList?.forEach((sec, index) => {
          dynamicFields[`section_${index}`] = sec.price || "0";
        });

        return {
          ...p,
          name: p.name || "",
          code: p.code || "",
          category: p.category?.guid || "",
          group: p.group?.guid || "",
          cost: p.cost || 0,
          basePrice: p.basePrice || 0,
          ...dynamicFields,   // ⭐ required for export
        };
      })
    );
  }
}, [productList]);


const [selectedCategory, setSelectedCategory] = useState("");
const [selectedGroup, setSelectedGroup] = useState("");

const filteredProducts = editableList?.filter((item) => {
  const matchesSearch =
    item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.code?.toLowerCase().includes(searchText.toLowerCase());

  const matchesCategory =
    !selectedCategory || item.category === selectedCategory;

  const matchesGroup = !selectedGroup || item.group === selectedGroup;

  return matchesSearch && matchesCategory && matchesGroup;
});

const handleInputChange = (id, field, value) => {
  setEditableList(prev =>
    prev.map(p =>
      p.id === id ? { ...p, [field]: value } : p
    )
  );
};

const handleSectionPriceChange = (productId, sectionIndex, value) => {
  setEditableList(prev =>
    prev.map(p => {
      if (p.id !== productId) return p;
      const updatedSections = [...p.sectionWiseProductDetailList];
      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        price: value,
      };
      return { ...p, sectionWiseProductDetailList: updatedSections };
    })
  );
};

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const modifiedList = productList?.filter(
    (value) =>
      value.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      value.code?.toLowerCase().includes(searchText?.toLowerCase())
  );


  const staticcolumns = [
  {
    title: "Name",
    dataIndex: "name",
    render: (_, record) => record.name,
    sorter: (a, b) => a.name.localeCompare(b.name),
    // render: (_, record) => (
    //   <input
    //     type="text"
    //     className="productimport"
    //     value={record.name}
    //    // onChange={(e) => handleInputChange(record.id, "name", e.target.value)}
    //   />
    // ),
  },
  {
    title: "Code",
    dataIndex: "code",
    render: (_, record) => record.code,
    sorter: (a, b) => a.code.localeCompare(b.code),
    // render: (_, record) => (
    //   <input
    //     type="text"
    //     className="productimport-other"
    //     value={record.code}
    //   //  onChange={(e) => handleInputChange(record.id, "code", e.target.value)}
    //   />
    // ),
  },
  // {
  //   title: "Category",
  //   dataIndex: "category",
  //   render: (_, record) => (
  //     <select
  //       className="productimport"
  //       value={record.category}
  //       // onChange={(e) =>
  //       //   handleInputChange(record.id, "category", e.target.value)
  //       // }
  //     >
  //       <option value="">Select Category</option>
  //       {categoryList?.map((obj) => (
  //         <option key={obj.id} value={obj.guid}>
  //           {obj.name}
  //         </option>
  //       ))}
  //     </select>
  //   ),
  // },
  // {
  //   title: "Group",
  //   dataIndex: "group",
  //   render: (_, record) => (
  //     <select
  //       className="productimport"
  //       value={record.group}
  //      // onChange={(e) => handleInputChange(record.id, "group", e.target.value)}
  //     >
  //       <option value="">Select Group</option>
  //       {groupList?.map((obj) => (
  //         <option key={obj.id} value={obj.guid}>
  //           {obj.name}
  //         </option>
  //       ))}
  //     </select>
  //   ),
  // },
  {
    title: "Cost",
    dataIndex: "cost",
    render: (_, record) => (
      <input
        type="number"
        className="productimport-other"
        value={record.cost}
        onChange={(e) => handleInputChange(record.id, "cost", e.target.value)}
      />
    ),
  },
  {
    title: "Base Price",
    dataIndex: "basePrice",
    render: (_, record) => (
      <input
        type="number"
        className="productimport-other"
        value={record.basePrice}
        onChange={(e) =>
          handleInputChange(record.id, "basePrice", e.target.value)
        }
      />
    ),
  },
  {
  title: "Is Active",
  dataIndex: "isActive",
  render: (_, record) => (
    <Switch
      size="small"
      checked={record.isActive}
      onChange={(checked) =>
        handleInputChange(record.id, "isActive", checked)
      }
         style={{
    backgroundColor: record.isActive ? "#ffa54a": "#092f57", // navy for ON
  }}
    />
  ),
},
{
  title: "Menu Item",
  dataIndex: "isMenuItem",
  render: (_, record) => (
    <Switch
      size="small"
      checked={record.isMenuItem}
      onChange={(checked) =>
        handleInputChange(record.id, "isMenuItem", checked)
      }
         style={{
    backgroundColor: record.isMenuItem ? "#ffa54a": "#092f57", // navy for ON
  }}
    />
  ),
},
  {
    title: "Stock Item",
    dataIndex: "isStockItem",
    key: "isStockItem",
    render: (_, record) => (
      <Switch
      size="small"
        checked={record.isStockItem || false}
        onChange={(checked) => {
          handleInputChange(record.id, "isStockItem", checked);

          // if user disables stock item → also disable daily stock
          if (!checked) {
            handleInputChange(record.id, "isDailyStockItem", false);
          }
        }}
   style={{
    backgroundColor: record.isStockItem ? "#ffa54a": "#092f57", // navy for ON
  }}
      />
    ),
  },
  {
    title: "Daily Stock Item",
    dataIndex: "isDailyStockItem",
    key: "isDailyStockItem",
    render: (_, record) => (
      <Switch
      size="small"
        checked={record.isDailyStockItem || false}
        disabled={!record.isStockItem} // disable if not a stock item
        onChange={(checked) =>
          handleInputChange(record.id, "isDailyStockItem", checked)
        }
           style={{
    backgroundColor: record.isDailyStockItem ? "#ffa54a": "#092f57", // navy for ON
  }}
      />
    ),
  },

// {
//   title: "Stock Item",
//   dataIndex: "isDailyStockItem",
//   render: (_, record) => (
//     <Switch
//       size="small"
//       checked={record.isDailyStockItem}
//       checkedChildren="Daily"
//       unCheckedChildren="Continuous"
//       onChange={(checked) =>
//         handleInputChange(record.id, "isDailyStockItem", checked)
//       }
//     />
//   ),
// },

{
  title: "Variable Price",
  dataIndex: "isRateVaryProduct",
  render: (_, record) => (
    <Switch
      size="small"
      checked={record.isRateVaryProduct}
      onChange={(checked) =>
        handleInputChange(record.id, "isRateVaryProduct", checked)
      }
                 style={{
    backgroundColor: record.isRateVaryProduct ? "#ffa54a": "#092f57", // navy for ON
  }}
    />
  ),
},

];


  const dynamicColumns = sectionList?.map((obj, index) => ({
  title: obj?.name,
  dataIndex: `section_${index}`, 
  render: (_, record) => (
    <input
      type="number"
      className="productimport-other"
      value={record?.sectionWiseProductDetailList?.[index]?.price || ""}
      onChange={(e) =>
        handleSectionPriceChange(record.id, index, e.target.value)
      }
    />
  ),
}));

  const columns = [...staticcolumns, ...dynamicColumns];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

    const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };

    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);

    // Return the filtered data, columns, and field mapping
    return { data: filteredProducts, columns: columns, fieldMapping , Rname:"Bulk Price Edit Report"};
  };

   const handlerefresh = () => {
        dispatch(fetchProduct(branch));
    dispatch(fetchSection(branch.guid));
    dispatch(fetchCategory(branch.guid));
    dispatch(fetchGroup(branch.guid));
      setSearchText("");
    };


// const onSubmit = async () => {
//   try {
//     const payload = {
//       branch: { guid: branch?.guid },
//       productList: editableList.map(p => ({
//         ...p,
//         category: { guid: p.category },
//         group: { guid: p.group },
//       })),
//     };
//     const res = await SaveProductBulkPrice(payload);
//     toast.success("Bulk prices updated successfully!");
//   } catch (err) {
//     toast.error("Save failed!");
//     console.error(err);
//   }
// };

const onSubmit = async () => {
  try {
    const payload = {
      branch: { guid: branch?.guid },
      productList: editableList.map(p => ({
        ...p,
        category: { guid: p.category },
        group: { guid: p.group },
      })),
    };

    const res = await SaveProductBulkPrice(payload);

    if (res) {
      toast.success("Bulk prices updated successfully!");

      // 🔄 Re-fetch product data so UI reflects changes
      dispatch(fetchProduct(branch));
    } else {
      toast.error("Save failed!");
    }
  } catch (err) {
    toast.error("Save failed!");
    console.error(err);
  }
};


  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Bulk Price Edit</h4>
              </div>
            </div>
               <ul className="table-top-head">
                         {/* <li>
                           <OverlayTrigger placement="top" overlay={renderTooltip}>
                             <Link
                               onClick={() => exportMasterPDF(getActiveTabData, "bulkedit")}
                             >
                               <ImageWithBasePath
                                 src="assets/img/icons/pdf.svg"
                                 alt="img"
                               />
                             </Link>
                           </OverlayTrigger>
                         </li> */}
                         <li>
                           <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                             <Link
                               data-bs-toggle="tooltip"
                               data-bs-placement="top"
                               onClick={() => exportMasterExcel(getActiveTabData, "bulkedit")}
                             >
                               <ImageWithBasePath
                                 src="assets/img/icons/excel.svg"
                                 alt="img"
                               />
                             </Link>
                           </OverlayTrigger>
                         </li>
                         {/* <li>
                           <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                             <Link
                               data-bs-toggle="tooltip"
                               data-bs-placement="top"
                               onClick={() => printMasterReport(getActiveTabData, "bulkedit")}
                             >
                               <i data-feather="printer" className="feather-printer" />
                             </Link>
                           </OverlayTrigger>
                         </li> */}
                         <li>
                           <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                             <Link
                               data-bs-toggle="tooltip"
                               data-bs-placement="top"
                               onClick={handlerefresh}
                             >
                               <RotateCcw />
                             </Link>
                           </OverlayTrigger>
                         </li>
                         <li>
                           <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                             <Link
                               data-bs-toggle="tooltip"
                               data-bs-placement="top"
                               id="collapse-header"
                               className={togglehead ? "active" : ""}
                               onClick={handletogglehead}
                             >
                               <ChevronUp />
                             </Link>
                           </OverlayTrigger>
                         </li>
                       </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              {/* <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search by Name/Code"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div> */}
<div className="table-top">
  <div className="search-set">
    <div className="search-input">
      <Link to="#" className="btn btn-searchset">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-search"
        >
          <circle cx={11} cy={11} r={8} />
          <line x1={21} y1={21} x2="16.65" y2="16.65" />
        </svg>
      </Link>
      <div id="DataTables_Table_0_filter" className="dataTables_filter">
        <label>
          <input
            type="search"
            className="form-control form-control-sm"
            placeholder="Search by Name/Code"
            value={searchText}
            onChange={handleSearch}
          />
        </label>
      </div>
    </div>
  </div>

  {/* New Category and Group filters */}
  <div className="col-12 md-6 mb-2 d-flex align-items-center gap-3">
    <select
      className="form-select"
      style={{ width: "180px" }}
      value={selectedCategory}
      onChange={(e) => setSelectedCategory(e.target.value)}
    >
      <option value="">All Categories</option>
      {categoryList?.map((obj) => (
        <option key={obj.guid} value={obj.guid}>
          {obj.name}
        </option>
      ))}
    </select>

    <select
      className="form-select"
      style={{ width: "180px" }}
      value={selectedGroup}
      onChange={(e) => setSelectedGroup(e.target.value)}
    >
      <option value="">All Groups</option>
      {groupList?.map((obj) => (
        <option key={obj.guid} value={obj.guid}>
          {obj.name}
        </option>
      ))}
    </select>
  </div>
</div>

              <div className="table-responsive product-list">
                {/* <AdminProductTable
                  columns={columns}
                  dataSource={modifiedList}
                /> */}
                {/* <AdminProductTable columns={columns} dataSource={editableList} /> */}
                <AdminProductTable columns={columns} dataSource={filteredProducts} />

              </div>
              <div className="col-lg-12">
                <div className="modal-footer-btn mb-4">
                  <button type="submit" className="btn btn-submit"    onClick={onSubmit}>
                    
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <AddPurchases />
      <ImportPurchases />
      <EditPurchases /> */}
    </div>
  );
};

export default BulkEdit;
